import {
  HTTP
} from '@/http';

export function getNewsFromInvesting(language) {
  if (language == null) language = 'es';
  return HTTP.get(`news/investing/` + language);
};



// WEBPACK FOOTER //
// ./src/services/NewsService.js